import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var FlowZeroResult = function FlowZeroResult(_ref) {
  var searchTerm = _ref.searchTerm;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-9 pt-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/zero-result-illustration.svg",
    alt: "",
    width: 96,
    height: 80,
    className: "md:w-[136px] md:h-[134px]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-[#00143C] text-xl md:text-3xl font-bold text-center"
  }, tShort("sell_trade_v2/zero_result_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#B0B0B0] text-sm text-center font-semibold md:text-xl"
  }, tShort("sell_trade_v2/zero_result_sub", {
    ns: "web_sell_trade"
  }).replace("{searchTerm}", searchTerm)))))));
};
export default FlowZeroResult;